export default {
  selected: { borderRight: 'solid 3px', borderColor: '#03cf00' },
  text: { fontWeight: 350 },
  alignCenter: { alignSelf: 'center' }
};
